import { getRuntimeEnv } from '@explorer/helpers';

import { ApiClientAuth } from '../../types';

export const getApiMapping = (): ApiMapping => ({
  monit: {
    url: getRuntimeEnv('API_MONIT', 'MISSING_API_MONIT'),
    prefix: '',
    auth: 'bearer',
  },
  cyberrisk: {
    url: getRuntimeEnv('API_CYBERRISK', 'MISSING_API_CYBERRISK'),
    prefix: '',
    auth: 'x-token',
  },
  execrisk: {
    url: getRuntimeEnv('API_EXECRISKS', 'MISSING_API_EXECRISKS'),
    prefix: '',
    auth: 'bearer',
  },
  breach: {
    url: getRuntimeEnv('API_BREACH', 'MISSING_API_BREACH'),
    prefix: '',
    auth: 'bearer',
  },
  v1notifications: {
    url: getRuntimeEnv('API_PORTAL', 'MISSING_API_PORTAL'),
    prefix: '/v1/notifications/web',
    auth: 'bearer',
  },
  v1monit: {
    url: getRuntimeEnv('API_PORTAL', 'MISSING_API_PORTAL'),
    prefix: '/v1/monit/web',
    auth: 'bearer',
  },
  v1cra: {
    url: getRuntimeEnv('API_PORTAL', 'MISSING_API_PORTAL'),
    prefix: '/v1/cra/web',
    auth: 'bearer',
  },
  v1execrisk: {
    url: getRuntimeEnv('API_PORTAL', 'MISSING_API_PORTAL'),
    prefix: '/v1/execrisks/web',
    auth: 'bearer',
  },
  v1secreview: {
    url: getRuntimeEnv('API_PORTAL', 'MISSING_API_PORTAL'),
    prefix: '/v1/secreview/web',
    auth: 'bearer',
  },
  supplemental: {
    url: getRuntimeEnv('API_PORTAL', 'MISSING_API_PORTAL'),
    prefix: '',
    auth: 'bearer',
  },
});

// Lazy-loaded to ensure window.env is available at runtime
let localApiMapping: ApiMapping | null = null;

export const API_MAPPING: ApiMapping = new Proxy({} as ApiMapping, {
  get(_target, prop) {
    if (!localApiMapping) {
      localApiMapping = getApiMapping();
    }
    return localApiMapping[prop as keyof ApiMapping];
  },
});

type ApiMapping = Record<
  MonorepoAPIs,
  {
    url: string;
    prefix: string;
    auth: ApiClientAuth;
  }
>;
